<template>
  <div class="wrapper">
    <div class="header">
    </div>
    <div class="content">
      <div class="hot">
        <div class="title">FAQ</div>
        <div class="q-list">
          <div v-for="(item, index) in hots" :key="index">
            <div
                @click="openDetail(index, 'hot')"
                class="item f-row f-justify-between f-align-center"
            >
              <div class="f-row f-align-center">
                <span class="block"></span>
                <span class="txt">{{ item.title }}</span>
              </div>
              <span class="arrow-right"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="cat">
        <div class="title">
          <div class="nav-item" v-for="(item, index) in cates" :key="index">
                        <span
                            @click="num = index"
                            :class="{ active: num == index }"
                        >{{ item.title }}</span
                        >
          </div>
        </div>
        <div v-for="(item, index) in cates" :key="index">
          <div class="q-list" v-show="num == index">
            <div v-for="(list, k) in item.list" :key="k">
              <div
                  @click="openDetail(k, item.type)"
                  class="item f-row f-justify-between f-align-center"
              >
                <div class="f-row f-align-center">
                  <span class="block"></span>
                  <span class="txt">{{ list.title }}</span>
                </div>
                <span class="arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-none"></div>
    <div @click="jumpContact" class="contact">
      <div class="btn f-row f-justify-start f-align-start">

      </div>
    </div>
  </div>
</template>

<script>
import { cate, getFaqArticlesForLang, resolveArticleByTag, supportedFaqLang } from './data'
import { executeInteraction } from '@/utils/bridge'
import { getUrlQueryString } from '@/utils/util'
export default {
  name: 'helpCenter',
  components: { },
  props: {},
  data() {
    return {
      num: 0,
      cates: cate,
      hots: [],
      lang: 'en'
    }
  },
  computed: {},
  watch: {},
  created() {
    const index = getUrlQueryString("index")
    console.log("index",index)
    if (index != "undefined" && index != null) {
      this.num = index
    }

    const queryLang = this.$route.query.lang || getUrlQueryString("lang") || 'en'
    this.lang = supportedFaqLang(queryLang)
    console.log("lang", this.lang)
    this.hots = getFaqArticlesForLang(this.lang)
    console.log("hots",this.hots)

    const tag = this.$route.query.tag || getUrlQueryString("tag")
    if (resolveArticleByTag(tag, this.lang)) {
      this.$router.replace({
        name: 'ArticleTagContent',
        params: { tag },
        query: { lang: this.lang }
      })
    }
  },
  mounted() {},
  methods: {
    openDetail(id, type) {
      const item = type === 'hot' ? this.hots[id] : null
      if (item && item.tag) {
        this.$router.push({
          name: 'ArticleTagContent',
          params: { tag: item.tag },
          query: { lang: this.lang }
        })
        return
      }
      this.$router.push({path: '/content/' + id + '/' + type, query: { lang: this.lang }});
    },
    jumpContact() {
      let param = {
        url: 'ticket://mine/custom'
      }
      executeInteraction('route', JSON.stringify(param))
    }
  }
}
</script>

<style lang="less" scoped>

.wrapper {
  min-height: 100vh;
  background: #fff;
  color: #000;
  .header {
    position: relative;
    font-size: 0;
    padding: 0 40px;
    .bg {
      display: block;
      width: 100%;
    }
  }
  .content {
    min-height: 100vh;
    padding: 45px 40px 10px 40px;
    background: #fff;
    .hot {
      margin-top: 0;
      .title {
        margin-bottom: 52px;
        font-size: 46px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 64px;
        color: #000;

      }
      .q-list {
        background-color: #fff;
        padding: 45px 30px;
        border-radius: 0;
        border: 1px solid #fff;
        .item {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 12px;
          column-gap: 24px;
          justify-content: normal;
          min-height: 92px;
          padding: 0 0 34px;
          align-items: flex-start;
          &:last-child {
            padding-bottom: 0;
          }
          > .f-row {
            display: grid;
            grid-template-columns: 23px minmax(0, 1fr);
            column-gap: 26px;
            min-width: 0;
            width: auto;
            align-items: flex-start;
          }
          .block {
            width: 23px;
            height: 23px;
            background: linear-gradient(
                270deg,
                #ababab 0%,
                #f7f7f7 100%
            );
            border-radius: 100%;
            margin: 19px 0 0;
          }
          .txt {
            display: block;
            min-width: 0;
            max-width: 100%;
            font-size: 40px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 60px;
            color: #0000ee;
            cursor: pointer;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: normal;
          }
          .arrow-right {
            border-top: 2px solid #ababab;
            border-right: 2px solid #ababab;
            width: 12px;
            height: 12px;
            margin-top: 22px;
            transform: rotate(45deg);
          }
        }
      }
    }
    .cat {
      margin-top: 65px;
      .nav-item {
        display: inline-block;
        margin-top: 20px;
      }
      .title {
        text-align: left;
        margin-bottom: 52px;
        span {
          margin-right: 60px;
          margin-bottom: 52px;
          font-size: 46px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 400;
          line-height: 64px;
          color: #000;
        }
        .active {
          font-size: 46px;
          font-weight: 600;
          padding-bottom: 10px;
          text-decoration: none;
          border-bottom: 10px solid #000;
        }
      }
      .q-list {
        background-color: #fff;
        padding: 45px 30px;
        border-radius: 0;
        border: 1px solid #fff;
        .item {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 12px;
          column-gap: 24px;
          justify-content: normal;
          min-height: 92px;
          padding: 0 0 34px;
          align-items: flex-start;
          &:last-child {
            padding-bottom: 0;
          }
          > .f-row {
            display: grid;
            grid-template-columns: 23px minmax(0, 1fr);
            column-gap: 26px;
            min-width: 0;
            width: auto;
            align-items: flex-start;
          }
          .block {
            width: 23px;
            height: 23px;
            background: linear-gradient(
                270deg,
                #ababab 0%,
                #f7f7f7 100%
            );
            border-radius: 100%;
            margin: 19px 0 0;
          }
          .txt {
            display: block;
            min-width: 0;
            max-width: 100%;
            font-size: 40px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 60px;
            color: #0000ee;
            cursor: pointer;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: normal;
          }
          .arrow-right {
            border-top: 2px solid #ababab;
            border-right: 2px solid #ababab;
            width: 12px;
            height: 12px;
            margin-top: 22px;
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  .foot-none {
    width: 100%;
    height: 185px;
  }
  .contact {
    position: fixed;
    left: calc(0% - 0px);
    bottom: 61px;

    .btn {
      width: 399px;
      height: 264px;
      img {
        width: 399px;
      }
    }
  }
}
</style>
